webpackJsonp([1,0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _adLoader = __webpack_require__(1);
	
	var _adLoader2 = _interopRequireDefault(_adLoader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var adLoader = (0, _adLoader2.default)({
	  targetingValue: 'state-of-mind'
	});
	adLoader.init();

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getMatchingAttributes = __webpack_require__(4);
	
	var _getMatchingAttributes2 = _interopRequireDefault(_getMatchingAttributes);
	
	var _loadScript = __webpack_require__(5);
	
	var _loadScript2 = _interopRequireDefault(_loadScript);
	
	var _objectAssign = __webpack_require__(6);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _selectAll = __webpack_require__(7);
	
	var _selectAll2 = _interopRequireDefault(_selectAll);
	
	var _uniqueId = __webpack_require__(8);
	
	var _uniqueId2 = _interopRequireDefault(_uniqueId);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * AdLoader
	 *
	 * @param  {Object} opts
	 * @return {Object}
	 */
	function AdLoader(opts) {
	  var w = window;
	  var hasBeenInit = false;
	  var adSlots;
	
	  var defaultOpts = {
	    attributePrefix: 'dv-gpt-',
	    defaultAdFields: {
	      adUnit: '/5805113/basic',
	      dimensions: [300, 250]
	    },
	    globalMappings: {
	      banner: [[[768, 130], [[728, 90]]]],
	      smallBanner: [[[508, 100], [[468, 60]]]]
	    },
	    gptSrc: 'https://www.googletagservices.com/tag/js/gpt.js',
	    idPrefix: 'dv-gpt-',
	    selector: '.dv-gpt-ad',
	    targetingKey: 'tribpedia',
	    targetingValue: null
	  };
	
	  opts = (0, _objectAssign2.default)({}, defaultOpts, opts);
	
	  var adElements = (0, _selectAll2.default)(opts.selector);
	
	  function setupService() {
	    w.googletag.cmd.push(function () {
	      var pubads = w.googletag.pubads();
	
	      if (opts.targetingKey && opts.targetingValue) {
	        pubads.setTargeting(opts.targetingKey, opts.targetingValue);
	      }
	
	      pubads.enableSingleRequest();
	      w.googletag.enableServices();
	    });
	  }
	
	  function createAds() {
	    adSlots = adElements.map(function (element) {
	      var matchingAttributes = (0, _getMatchingAttributes2.default)(element, opts.attributePrefix);
	      var localOpts = (0, _objectAssign2.default)({}, opts.defaultAdFields, matchingAttributes);
	
	      var adElementId = (0, _uniqueId2.default)(opts.idPrefix);
	      element.setAttribute('id', adElementId);
	
	      var adUnit = w.googletag.defineSlot(localOpts.adUnit, localOpts.dimensions, adElementId);
	
	      if (localOpts.mapping && opts.globalMappings.hasOwnProperty(localOpts.mapping)) {
	        adUnit.defineSizeMapping(opts.globalMappings[localOpts.mapping]);
	      }
	
	      if (localOpts.targetingKey && localOpts.targetingValue) {
	        adUnit.setTargeting(localOpts.targetingKey, localOpts.targetingValue);
	      }
	
	      adUnit.setCollapseEmptyDiv(true);
	      adUnit.addService(w.googletag.pubads());
	
	      w.googletag.display(adElementId);
	
	      return adUnit;
	    });
	  }
	
	  function init() {
	    if (hasBeenInit) return;
	
	    (0, _loadScript2.default)(opts.gptSrc, function () {
	      w.googletag.cmd.push(setupService, createAds);
	
	      hasBeenInit = true;
	    });
	  }
	
	  return {
	    adSlots: adSlots,
	    init: init
	  };
	}
	
	exports.default = AdLoader;

/***/ },
/* 2 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = camelCase;
	/**
	 * Converts a string from dash or underscore separated to camelCase.
	 *
	 * @param  {String} str
	 * @return {String}
	 */
	function camelCase(str) {
	  // remove any dashes or underscores in the string, and grab the following character
	  return str.replace(/[-_]+(\w?)/g, function (match, p1) {
	    // uppercase the following letter
	    return p1.toUpperCase();
	  });
	}

/***/ },
/* 3 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getAttributes;
	/**
	 * Gets all the attributes set on an element, and returns them as an Object.
	 *
	 * @param  {Element} element
	 * @return {Object}
	 */
	function getAttributes(element) {
	  var attrs = {};
	
	  // if element is empty, or not ELEMENT_NODE, eject
	  if (!element || element.nodeType !== 1) return attrs;
	
	  // grab all the attributes off the element
	  var map = element.attributes;
	
	  // if there are no attributes, eject
	  if (map.length === 0) return attrs;
	
	  // loop through the attributes and build the object
	  for (var i = 0; i < map.length; i++) {
	    attrs[map[i].name] = map[i].value;
	  }
	
	  return attrs;
	}

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getMatchingAttributes;
	
	var _camelCase = __webpack_require__(2);
	
	var _camelCase2 = _interopRequireDefault(_camelCase);
	
	var _getAttributes = __webpack_require__(3);
	
	var _getAttributes2 = _interopRequireDefault(_getAttributes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Searches an element's attributes and returns an Object of all the ones that
	 * begin with a specified prefix. Each matching attribute name is returned
	 * without the prefix, with the remainder converted to camelCase.
	 *
	 * @param  {Element} element
	 * @param  {String} prefix
	 * @return {Object}
	 */
	function getMatchingAttributes(element, prefix) {
	  // get all the attributes on the element
	  var attributes = (0, _getAttributes2.default)(element);
	  var fields = {};
	
	  // loop through the keys of the attributes
	  Object.keys(attributes).forEach(function (key) {
	    // continue if the key begins with supplied prefix
	    if (key.substr(0, prefix.length) === prefix) {
	      // grab the value associated with the original key
	      var value = attributes[key];
	
	      // slice off the prefix and camelCase what is left
	      var field = (0, _camelCase2.default)(key.slice(prefix.length));
	
	      fields[field] = value;
	    }
	  });
	
	  return fields;
	}

/***/ },
/* 5 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * A helper for asynchronously loading scripts.
	 *
	 * Provides a callback interface for passing a function that will only be called
	 * if the script is successfully added to the page.
	 *
	 * @private
	 * @param {String} url The URL for the script to be loaded.
	 * @param {Function} [cb] A function to be called once the script successfully
	 * loads. Not required.
	 * @returns {void}
	 * @example
	 *
	 * loadScript('backup.js', function () {
	 *   // anything that depends on that script loading
	 * });
	 */
	function loadScript(url, cb) {
	  // create the `script` element
	  var script = document.createElement('script');
	
	  // set its URL
	  script.src = url;
	
	  // if there is a supplied callback, add it to `onload`
	  if (cb) script.onload = cb;
	
	  // attach the script to the document body
	  document.body.appendChild(script);
	}
	
	exports.default = loadScript;

/***/ },
/* 6 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var objectAssign = Object.assign || function objectAssign(target, varArgs) {
	  if (target == null) {
	    throw new TypeError('Cannot convert undefined or null to object');
	  }
	
	  var output = Object(target);
	
	  for (var idx = 1; idx < arguments.length; idx++) {
	    var source = arguments[idx];
	
	    if (source != null) {
	      for (var key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          output[key] = source[key];
	        }
	      }
	    }
	  }
	
	  return output;
	};
	
	exports.default = objectAssign;

/***/ },
/* 7 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/* global Node, Window */
	
	/**
	 * Select all matching elements on the page. Uses `document.querySelectorAll`.
	 *
	 * @param {String} el The CSS selector to search for.
	 * @param {Element} [context] The container to search within. Defaults to
	 * `document`.
	 * @returns {Element[]}
	 */
	function selectAll(el, context) {
	  // if `el` is a Node or Window, return it in an Array
	  if (el instanceof Node || el instanceof Window) return [el];
	
	  return Array.prototype.slice.call(typeof el === 'string' ? (context || document).querySelectorAll(el) : el || []);
	}
	
	exports.default = selectAll;

/***/ },
/* 8 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = uniqueId;
	// Borrowed from underscore.js: http://underscorejs.org/#uniqueId
	/**
	 * Counter used by {uniqueId} to iterate.
	 * @private
	 * @type {Number}
	 */
	var idCounter = 0;
	
	/**
	 * Generates identifiers unique to a single browser session. Each time it runs,
	 * the integer at the end of the return value will increment.
	 *
	 * @param  {String} [prefix] Optional prefix for identifier
	 * @return {String}
	 * @example
	 *
	 * var identifier = uniqueId();
	 * // returns '1'
	 *
	 * var prefixedIdentifier = uniqueId('label-');
	 * // returns 'label-2'
	 */
	function uniqueId(prefix) {
	  var id = ++idCounter + '';
	  return prefix ? prefix + id : id;
	}

/***/ }
]);


// WEBPACK FOOTER //
// main.js